import React, { useEffect, useState } from "react";
import { Container, Row, Col, Form, Card } from "react-bootstrap";
import { DASHBOARD_DATA } from "../../../services/ApiCalls";
import { checkResponse, catchAsync } from "../../../utilities/utilities";
import Loader from "../../../components/Common/Loader";
import FeatureCard from "./components/FeatureCard";
import RevenueChart from "./components/RevenueChart";
import BookingChart from "./components/BookingChart";
import HotelList from "./components/HotelList";
import TopHotelList from "./components/TopPerfomer";
import NewHotelList from "./components/newlyHotel";
import { useTranslation } from "react-i18next";
const Dashboard = () => {
  const [dashboardData, setDashboardData] = useState(null);
  const [loader, setLoader] = useState(false);
  const todayActiveUser = dashboardData?.filteredData?.todayActiveUser || {};
  const [filter, setFilter] = useState("today");
  const { t } = useTranslation();

  const getData = catchAsync(async () => {
    setLoader(true);
    const res = await DASHBOARD_DATA({ filter });

    checkResponse({ res, setData: setDashboardData, setLoader });
  }, setLoader);

  useEffect(() => {
    getData();
  }, [filter]);

  const activeUserList = [
    { label: t("dashboard.columns.today"), value: todayActiveUser?.today?.[0]?.count || 0 },
    { label: t("dashboard.columns.last7"), value: todayActiveUser?.last7day?.[0]?.count || 0 },
    {
      label: t("dashboard.columns.last30"),
      value: todayActiveUser?.last30Days?.[0]?.count || 0,
    },
  ];

  const requests = [
    { label: t("dashboard.columns.bookingIssue"), statusLabel: t("dashboard.columns.pending"), status: "Pending", color: "bg-success" },
    { label: t("dashboard.columns.paymentFailed"), statusLabel: t("dashboard.columns.pending"), status: "Pending", color: "bg-success" },
    { label: t("dashboard.columns.roomChange"), statusLabel: t("dashboard.columns.solved"), status: "Solved", color: "bg-danger" },
    { label: t("dashboard.columns.lateCheckIn"), statusLabel: t("dashboard.columns.solved"), status: "Solved", color: "bg-danger" },
  ];

  return (
    <>
      {loader && <Loader />}
      <section className="position-relative py-2">
        <Container>
          <Row>
            <Col lg="12">
              <div className="d-flex justify-content-between">
                <h4 className="mb-0  fw-bold text-dark">
                  {t("dashboard.title")}
                </h4>
                <Form.Select
                  value={filter}
                  onChange={(e) => setFilter(e.target.value)}
                  className="w-auto"
                >
                  <option value="today">{t("dashboard.columns.today")}</option>
                  <option value="week">{t("dashboard.columns.thisWeek")}</option>
                  <option value="month">{t("dashboard.columns.thisMonth")}</option>
                </Form.Select>
              </div>
            </Col>

            <Col lg="12" className="my-2">
              <FeatureCard dashboardData={dashboardData} />
            </Col>

            <Col md="5" className="my-2">
              <div className="d-flex flex-column gap-3 ">
                <div className="cardCstm border rounded  p-3 py-lg-4 d-flex align-items-center justify-content-between gap-10 mb-3">
                  <div className="content h-100 ">
                    <h6 className="m-0 fw-bold py-1 text-dark fs-6">
                      {t("dashboard.totalRevenue","Total Revenue")}
                    </h6>
                    <h4 className="m-0 fw-bold themeBlue py-1">
                      {dashboardData?.platform?.revenue}
                    </h4>
                  </div>
                  <div
                    style={{
                      width: "1px",
                      backgroundColor: "#ccc",
                      margin: "0 10px",
                      height: "70px",
                    }}
                  ></div>
                  <div className="content h-100">
                    <h6 className="m-0 fw-bold py-1 text-dark fs-6">
                      {t("dashboard.totalBooking","Total Bookings")}
                    </h6>
                    <h4 className="m-0 fw-bold themeBlue py-1">
                      {dashboardData?.platform?.totalBooking}
                    </h4>
                  </div>
                </div>
                <div className="cardCstm border rounded p-3 py-lg-4 d-flex align-items-center gap-10 mb-3">
                  <div>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      version="1.1"
                      xmlnsXlink="http://www.w3.org/1999/xlink"
                      width={50}
                      height={50}
                      x="0"
                      y="0"
                      viewBox="0 0 512 512"
                      style={{ enableBackground: "new 0 0 512 512" }}
                      xmlSpace="preserve"
                    >
                      <g>
                        <path
                          d="M255.832 56.037c110.44.096 199.891 89.691 199.795 200.131s-89.691 199.891-200.131 199.795C145.127 455.867 55.701 366.368 55.701 256c.176-110.432 89.698-199.883 200.131-199.963m0-56.037C114.443.096-.096 114.779 0 256.168S114.779 512.096 256.168 512C397.485 511.904 512 397.317 512 256 511.952 114.571 397.261-.048 255.832 0z"
                          fill="#E8307A "
                          data-original="#E8307A "
                          className=""
                        />
                      </g>
                    </svg>
                  </div>
                  <div className="content">
                    <h6 className="m-0 fw-bold py-1 text-dark fs-6">
                      {t("dashboard.companyCommission")}
                    </h6>
                    <h4 className="m-0 fw-bold themeBlue py-1">
                      {dashboardData?.platform?.companyCommision || 0}
                    </h4>
                  </div>
                </div>
              </div>

              <RevenueChart
                dashboardData={dashboardData?.filteredData?.graphicalWay}
                filter={filter}
              />
              {/* customer request */}
              {/* <div className="mt-3">
                <h4 className="mb-3  fw-bold text-dark">{t("dashboard.companyCommission")}</h4>
                <ul className="list-unstyled mb-0 border rounded-3">
                  {requests.map((item, index) => (
                    <li
                      key={index}
                      className="d-flex justify-content-between border-bottom p-2 align-items-center mb-2"
                    >
                      <div className="d-flex  align-items-center gap-3">
                        <span
                          className={`rounded-circle ${item.color}`}
                          style={{ width: "8px", height: "8px" }}
                        ></span>
                        <span className="text-dark fs-6 small fw-medium">
                          {item.label}
                        </span>
                      </div>
                      <span
                        className={`small fw-medium fs-6 ${item.status === "Pending" ? "text-dark" : "text-muted"
                          }`}
                      >
                        {item.statusLabel}
                      </span>
                    </li>
                  ))}
                </ul>
              </div> */}
            </Col>

            <Col lg="7" className="mb-4">
              <div className="d-flex gap-3 flex-column">
                <HotelList
                  data={dashboardData?.filteredData?.todayTopHotel}
                  title={t("dashboard.pendingHotels")}
                />
              </div>

              {/* <Card className="cardCstm border-1 rounded-sm mt-3 ">
                <Card.Body className="p-4">
                  <h6 className="fw-bold text-dark mb-3">{t("dashboard.activeUser")}</h6>
                  <div className="d-flex  gap-3">
                    {activeUserList?.length > 0 ? (
                      activeUserList?.map((item, index) => (
                        <div
                          key={index}
                          className="d-flex flex-column justify-content-between align-items-center pb-2"
                        >
                          <span className="fw-semibold text-muted rounded-pill border px-2 py-1">
                            {item.label}
                          </span>
                          <h4 className="m-0 fw-bold themeBlue mt-3">
                            {item.value}
                          </h4>
                        </div>
                      ))
                    ) : (
                      <span className="text-muted">{t("dashboard.noActiveUsersFound")}</span>
                    )}
                  </div>
                </Card.Body>
              </Card> */}

              <div className="mt-3">
                <h6 className="fw-bold text-dark mb-3">
                  {t("dashboard.HotelRegister")}       
                           </h6>
                <table className="table border rounded-3 align-middle mb-0">
                  <thead>
                    <tr>
                      <th
                        scope="col"
                        className="text-secondary small fw-semibold fs-6"
                      >
                        {t("dashboard.columns.hotel")}
                      </th>
                      <th
                        scope="col"
                        className="text-secondary small fw-semibold fs-6"
                      >
                        {t("dashboard.columns.location")}
                      </th>
                      <th
                        scope="col"
                        className="text-secondary small fw-semibold fs-6"
                      >
                        {t("dashboard.columns.approval")}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {dashboardData?.filteredData?.registeredHotelData?.length >
                      0 ? (
                      dashboardData?.filteredData?.registeredHotelData?.map(
                        (item, index) => (
                          <tr key={index}>
                            <td className="d-flex align-items-center gap-2">
                              <span
                                className={`rounded-circle align-item-start ${item.color}`}
                                style={{ width: "8px", height: "8px" }}
                              ></span>
                              <span className="text-dark small fw-medium fs-6">
                                {item.hotelName}
                              </span>
                            </td>
                            <td className="text-muted small fs-6">
                              {item.address}
                            </td>
                            <td>
                              <span
                                className={`small fw-medium fs-6 ${item.status === "Active"
                                  ? "text-success"
                                  : "text-danger"
                                  }`}
                              >
                                {item.status === "Active"
                                  ? "✔ Approved"
                                  : "✖ Pending"}
                              </span>
                            </td>
                          </tr>
                        )
                      )
                    ) : (
                      <tr>
                        <td colSpan="3" className="text-center text-muted py-3">
                          {t("dashboard.noDataFound")}
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </Col>


          </Row>
        </Container>
      </section>
    </>
  );
};

export default Dashboard;
